import type { FC } from 'react';

import type { FormFieldProps } from '../FormField';
import FormSelect from '../FormSelect';
import { temperatureUnitOptions } from './helpers';
import type { TemperatureUnit } from './types';

interface Props extends FormFieldProps {
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormTemperatureUnitSelect: FC<Props> = (props) => (
  <FormSelect<TemperatureUnit> {...props} isSearchable={false} options={temperatureUnitOptions} />
);

export type { Props as FormTemperatureUnitSelectProps };
export default FormTemperatureUnitSelect;
